import React, { useState, useEffect } from 'react';
import { AlertDialog } from '@yola/ws-ui';
import PropTypes from 'prop-types';
import { t } from '../localization';
import { ONLINE, OFFLINE, WAITING_TIME, ICON } from './constants';

function NetworkErrorHandler({
  onShow = null,
  onHide = null,
  onDismiss = null,
  forceShow = false,
}) {
  const [networkStatus, setNetworkStatus] = useState(ONLINE);
  let timer;

  const handleOffline = () => {
    setNetworkStatus(OFFLINE);
    clearTimeout(timer);
    if (onShow) onShow();
  };

  const handleOnline = () => {
    timer = setTimeout(() => {
      setNetworkStatus(ONLINE);
      if (onHide) onHide();
    }, WAITING_TIME);
  };

  useEffect(() => {
    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);

    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  });

  const captions = {
    title: t('You seem to be offline'),
    description: t(
      'There is no internet connection. Please, fix your internet connection to continue working with the application'
    ),
    dismiss: t('Reload'),
  };

  return (
    <React.Fragment>
      {(networkStatus === OFFLINE || forceShow) && (
        <AlertDialog captions={captions} imgSrc={ICON} height="auto" onDismiss={onDismiss} />
      )}
    </React.Fragment>
  );
}

NetworkErrorHandler.propTypes = {
  onShow: PropTypes.func,
  onHide: PropTypes.func,
  onDismiss: PropTypes.func,
  forceShow: PropTypes.bool,
};

export default NetworkErrorHandler;
